import { IReduxAction } from '../../views/interfaces';
import { GET_REVENUE_PER_AVAILABLE_NIGHT_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const revenuePerAvailableNightReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_REVENUE_PER_AVAILABLE_NIGHT_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 